import { NavLink } from "react-router";
import { Clock, LayoutDashboard, Timer, ClipboardList, BarChart2, Building2, Settings, LogOut } from "lucide-react";
import { WorkspaceSwitcher } from "./WorkspaceSwitcher";
import { useAuth } from "../contexts/AuthContext";

const NAV_ITEMS = [
  { to: "/", label: "Dashboard", end: true, icon: LayoutDashboard },
  { to: "/timer", label: "Focus Timer", end: false, icon: Timer },
  { to: "/timesheets", label: "Timesheets", end: false, icon: ClipboardList },
  { to: "/analytics", label: "Analytics", end: false, icon: BarChart2 },
  { to: "/workspace", label: "Workspace", end: false, icon: Building2 },
  { to: "/settings", label: "Settings", end: false, icon: Settings },
];

export function Sidebar() {
  const { logout } = useAuth();

  return (
    <aside className="w-56 flex flex-col bg-card border-r border-white/[0.08] shrink-0">
      <div className="p-5 border-b border-white/[0.08] flex items-center gap-2.5">
        <Clock size={26} className="text-brand shrink-0" strokeWidth={2} />
        <h1 className="text-xl font-bold font-display bg-gradient-to-r from-brand to-amber bg-clip-text text-transparent">
          TimeCraftr
        </h1>
      </div>
      <WorkspaceSwitcher />
      <nav className="flex-1 p-2 space-y-0.5">
        {NAV_ITEMS.map(({ to, label, end, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition-colors ${
                isActive
                  ? "bg-brand/10 text-brand font-medium"
                  : "text-ink-3 hover:text-ink hover:bg-white/5"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={16} className="shrink-0" strokeWidth={isActive ? 2.5 : 2} />
                {label}
              </>
            )}
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-white/[0.08]">
        <button
          onClick={logout}
          className="w-full flex items-center gap-2.5 px-3 py-2 text-sm text-ink-3 hover:text-red-400 rounded-lg transition-colors"
        >
          <LogOut size={16} className="shrink-0" />
          Sign out
        </button>
      </div>
    </aside>
  );
}
